import React from "react";

const StatCard = ({ label, value, tone }) => (
  <div className="stat-card">
    <p className="stat-label">{label}</p>
    <p className={`stat-value${tone ? ` stat-value-${tone}` : ""}`}>{value}</p>
  </div>
);

export default StatCard;
